var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4 4.5a3.1 3.1 0 116.2 0 3.1 3.1 0 01-6.2 0zm3.1-1.9a1.9 1.9 0 100 3.8 1.9 1.9 0 000-3.8zM.9 12a3.6 3.6 0 013.6-3.6h4a3.6 3.6 0 013.6 3.6v1.2a1.4 1.4 0 01-1.4 1.4H2.3a1.4 1.4 0 01-1.4-1.4V12zm3.6-2.4A2.4 2.4 0 002.1 12v1.2c0 .11.09.2.2.2h8.4a.2.2 0 00.2-.2V12a2.4 2.4 0 00-2.4-2.4h-4zm6-7.2a2.6 2.6 0 011.891 4.385c.355.146.707.34 1.034.589.962.73 1.675 1.906 1.675 3.626v.065c0 .449.002 1.114-.35 1.643-.416.623-1.17.892-2.25.892v-1.2c.92 0 1.166-.23 1.25-.357.13-.195.15-.49.15-1.043 0-1.343-.537-2.167-1.2-2.67-.69-.524-1.556-.73-2.2-.73V6.4a1.4 1.4 0 100-2.8V2.4z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/external_accounts.965302db.svg";
export { SvgExternalAccounts as ReactComponent };